import { Link } from 'react-router-dom';
import './CategoryGrid.css';

const BUSINESSES = [
  {
    title: 'Kitchen Fitters',
    items: ['Sinks & taps', 'Appliance parts', 'Metal worktops', 'Metal shelving', 'Drawer runners'],
    image: '/images/businesses/biz-kitchen-fitters.png',
    tone: 'sage',
    to: '/kitchen-fitters',
  },
  {
    title: 'Plumbers & Heating Engineers',
    items: ['Copper pipes & fittings', 'Radiators', 'Boilers & tanks', 'Valves & metal parts', 'Pipe offcuts'],
    image: '/images/businesses/biz-plumbers-heating.png',
    tone: 'lime',
    to: '/plumbers-heating-engineers',
  },
  {
    title: 'Construction & Building Companies',
    items: ['Steel beams & sections', 'Metal studs & channels', 'Pipes & conduit', 'Wire mesh & rebar', 'Metal offcuts'],
    image: '/images/businesses/biz-construction.png',
    tone: 'forest',
    to: '/construction-building-companies',
  },
  {
    title: 'Garage Door & Roller Shutter Companies',
    items: ['Roller shutter slats', 'Tracks & guides', 'Springs & shafts', 'Motors & metal frames', 'Hinges & brackets'],
    image: '/images/businesses/biz-garage-doors.png',
    tone: 'sage',
    to: '/garage-door-roller-shutter-companies',
  },
  {
    title: 'HVAC & Air-Conditioning Companies',
    items: ['AC units & components', 'Ductwork & ventilation', 'Copper pipe & tubing', 'Metal brackets & frames', 'Vent covers & grilles'],
    image: '/images/businesses/biz-hvac.png',
    tone: 'lime',
    to: '/hvac-air-conditioning-companies',
  },
  {
    title: 'Vehicle Garages & Workshops',
    items: ['Exhausts & cats', 'Engine & gearbox parts', 'Wheels & rims', 'Brake discs & parts', 'Metal brackets'],
    image: '/images/businesses/biz-vehicle-garages.png',
    tone: 'forest',
    to: '/vehicle-garages-workshops',
  },
  {
    title: 'Fencing & Gate Installers',
    items: ['Metal gates & railings', 'Fence panels & posts', 'Steel tubing & sections', 'Decorative ironwork', 'Metal offcuts'],
    image: '/images/businesses/biz-fencing-gates.png',
    tone: 'sage',
    to: '/fencing-gate-installers',
  },
  {
    title: 'Junk & Waste Removal Companies',
    items: ['Appliances & white goods', 'Metal furniture & frames', 'Mixed metal scrap', 'General scrap metal', 'Pipes & offcuts'],
    image: '/images/businesses/biz-junk-waste.png',
    tone: 'lime',
    to: '/junk-waste-removal-companies',
  },
  {
    title: 'Property Management Companies',
    items: ['Old fixtures & fittings', 'Metal railings & grilles', 'Pipework & conduit', 'General building scrap', 'Metal offcuts'],
    image: '/images/businesses/biz-property-management.png',
    tone: 'forest',
    to: '/property-management-companies',
  },
  {
    title: 'Gym & Fitness Equipments',
    items: ['Gym machines & frames', 'Weight plates & bars', 'Treadmill parts', 'Metal racks & benches', 'Metal offcuts'],
    image: '/images/businesses/biz-gym-fitness.png',
    tone: 'sage',
    to: '/gym-fitness-equipments',
  },
];

export default function CategoryGrid() {
  return (
    <section className="biz-scrap-section" aria-labelledby="biz-scrap-heading">
      <div className="biz-scrap-banner">
        <div className="biz-scrap-banner-inner">
          <p className="biz-scrap-kicker">For trade & commercial partners</p>
          <h2 id="biz-scrap-heading">Businesses That Generate Scrap Metal</h2>
          <p className="biz-scrap-lead">
            These are some of the most common industries that regularly produce unwanted metal and
            scrap. SnapScrap provides a simple and responsible way to connect these businesses with
            licensed local scrap collectors.
          </p>
        </div>
      </div>

      <div className="biz-scrap-inner">
        <ul className="biz-scrap-grid">
          {BUSINESSES.map(({ title, items, image, tone, to }) => (
            <li key={title} className={`biz-scrap-card tone-${tone}`}>
              <Link className="biz-scrap-card-link" to={to || '/post-scrap'}>
                <div className="biz-scrap-card-top">
                  <div className="biz-scrap-card-copy">
                    <h3>{title}</h3>
                  </div>
                </div>

                <div className="biz-scrap-visual">
                  <img src={image} alt="" loading="lazy" />
                </div>

                <ul className="biz-scrap-items">
                  {items.map((item) => (
                    <li key={item}>{item}</li>
                  ))}
                </ul>

                <span className="biz-scrap-link">
                  {to ? 'View page →' : 'Clear this scrap →'}
                </span>
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
